import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import PrivateRoute from "./components/PrivateRoute";
import SignInPage from "./pages/signIn/SignInPage";

import Sucursales from "./pages/sucursal/Sucursales";
import DetalleSucursal from "./pages/sucursal/DetalleSucursal";

import Usuarios from "./pages/usuarios/Usuarios";
import DetalleUsuario from "./pages/usuarios/DetalleUsuarios";
import CambiarContrasena from "./pages/usuarios/CambiarContrasena";

import CategoriasPlatilloPage from "./pages/menu/categorias/CategoriasPlatillo";
import DetalleCategoriasPlatillo from "./pages/menu/categorias/DetalleCategoriasPlatillo";

import PlatillosPage from "./pages/menu/platillos/Platillos";
import DetallePlatillo from "./pages/menu/platillos/DetallePlatillo";

import Promociones from "./pages/promociones/Promociones";
import DetallePromocion from "./pages/promociones/DetallePromocion";

import Preferencias from "./pages/preferencias/Preferencias";
import DetallePreferencia from "./pages/preferencias/DetallePreferencia";

import Clientes from "./pages/clientes/Clientes";
import DetalleCliente from "./pages/clientes/DetalleCliente";

import Escaneos from "./pages/escaneos/Escaneos";
import DetalleEscaneo from "./pages/escaneos/DetalleEscaneo";

import Top from "./pages/top/Top";
import CategoriaOrden from "./pages/categoria_orden/CategoriaOrden";

import Reservaciones from "./pages/reservaciones/Reservaciones";

import Notificaciones from "./pages/notificaciones/Notificaciones";
import DetalleNotificaciones from "./pages/notificaciones/DetalleNotificaciones";

import ErrorPage from "./pages/ErrorPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import { AuthProvider } from "./auth/AuthProvider";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <SignInPage />,
  },
  {
    
    element:<PrivateRoute />,
    children: [
      {
        path: "/",
        element: <HomePageOne />,
      },
      {
        path: "/sucursales",
        element:<Sucursales />,
      },
      {
        path: "/sucursal/:id",
        element:<DetalleSucursal />,
      },
      {
        path: "/usuarios",
        element:<Usuarios />,
      },
      {
        path: "/usuario/:id",
        element: <DetalleUsuario />,
      },
      {
        path: "/cambiar-contrasena",
        element: <CambiarContrasena />,
      },
      {
        path: "/categorias-menu",
        element:<CategoriasPlatilloPage />,
      },
      {
        path: "/categoria_platillo/:id",
        element: <DetalleCategoriasPlatillo />,
      },
      {
        path: "/platillos",
        element:<PlatillosPage />,
      },
      {
        path: "/platillo/:id",
        element: <DetallePlatillo />,
      },
      {
        path: "/promociones",
        element: <Promociones />,
      },
      {
        path: "/promocion/:id",
        element: <DetallePromocion />,
      },
      {
        path: "/preferencias",
        element:<Preferencias />,
      },
      {
        path: "/preferencia/:id",
        element:<DetallePreferencia />,
      },
      {
        path: "clientes",
        element:<Clientes />,
      },
      {
        path: "/cliente/:id",
        element: <DetalleCliente />,
      },
      {
        path: "escaneos",
        element:<Escaneos />,
      },
      {
        path: "escaneo/:id",
        element:<DetalleEscaneo />,
      },
      {
        path: "top",
        element:<Top />,
      },
      {
        path: "categoria_orden",
        element:<CategoriaOrden />,
      },
      {
        path: "reservaciones",
        element:<Reservaciones />,
      },
      {
        path: "notificaciones",
        element:<Notificaciones />,
      },
      {
        path: "notificacion/:id",
        element:<DetalleNotificaciones />,
      },
      {
        path: "*",
        element: <ErrorPage />,
      },
    ]
  },
]);

function App() {
  return (
    <>
    <AuthProvider>
        <RouterProvider router={router}><RouteScrollToTop /></RouterProvider>
      </AuthProvider>
    </>
  );
}

export default App;



